module.exports = "../study/imgs/maps/Nagano/S8/WaterEnvironment/Chlmax/Nagano_Chlmax_HadGEM2_RCP45_Now.png";